import { withDependencies, multi } from '@wix/thunderbolt-ioc'
import { IPageWillMountHandler, IPropsStore, Props, AppStructure, PropsMap } from '@wix/thunderbolt-symbols'
import { PageStructureJsonSymbol, PagePropsJsonSymbol } from 'feature-pages'
import { IComponentPropsExtender } from './types'
import { ComponentPropsExtenderSymbol } from './symbols'

type ComponentTypeToExtenders = { [componentType: string]: Array<IComponentPropsExtender<{}, unknown>> }

const pageWillMountPropsExtender = (
	beckyPropsExtenders: Array<IComponentPropsExtender<{}>>,
	propsStore: IPropsStore,
	pageStructure: AppStructure,
	pageProps: PropsMap
): IPageWillMountHandler => {
	return {
		async pageWillMount() {
			const extendersPerComponentType = beckyPropsExtenders.reduce<ComponentTypeToExtenders>(
				(acc, singlePropsExtender) => {
					singlePropsExtender.componentTypes.forEach((componentType) => {
						acc[componentType] = acc[componentType] || []
						acc[componentType].push(singlePropsExtender)
					})
					return acc
				},
				{}
			)

			const extendedPropsPromises = Object.entries(pageStructure).map(async ([compId, { componentType }]) => {
				const allExtended = (extendersPerComponentType[componentType] || []).map((extender) =>
					extender.getExtendedProps(compId, pageProps[compId])
				)

				if (allExtended.length) {
					return { [compId]: Object.assign({}, ...(await Promise.all(allExtended))) }
				}

				return null
			})

			const extendedProps = Object.assign({}, ...(await Promise.all(extendedPropsPromises)))

			propsStore.update(extendedProps)
		},
	}
}

export const PageWillMountPropsExtender = withDependencies(
	[multi(ComponentPropsExtenderSymbol), Props, PageStructureJsonSymbol, PagePropsJsonSymbol],
	pageWillMountPropsExtender
)
